import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import { domOnlyProps } from 'utils/dom-only-props'

import styles from './checkbox.css'

const Checkbox = ({ data }) => (
  <input
    type="checkbox"
    {...domOnlyProps(data)}
  />
)

Checkbox.propTypes = {
  data: PropTypes.object.isRequired,
}

export default CSSModules(Checkbox, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/setupform-form/field/checkbox/checkbox.js
 **/